const Company = ({
    name = '',
    propertyCount = 0,
    userCount = 0,
    pendingUserCount = 0,
} = {}) => ({
    name: String(name),
    propertyCount: Number(propertyCount),
    userCount: Number(userCount),
    pendingUserCount: Number(pendingUserCount),
});

export default Company;
